import formFieldWidget from "./formFieldWidget.js";

/**
 * multipleField is the abstract superclass of all multiple fields.
 */
function multipleFieldWidget(spec, my) {
	spec ||= {};
	my ||= {};

	my.items = spec.items || [];

	my.itemLabel =
		spec.itemLabel ||
		function (item) {
			return item;
		};

	my.serialize =
		spec.serialize ||
		function (item) {
			return item;
		};

	my.deserialize =
		spec.deserialize ||
		function (item) {
			return item;
		};

	const that = formFieldWidget(spec, my);

	that.toggleAllItems = function () {
		if (my.items.some(my.isSelected)) {
			my.unselectAllItems();
		} else {
			my.selectAllItems();
		}
	};

	my.isSelected = function (item) {
		const selection = that.getValue() || [];
		return selection.some((value) => item === value);
	};

	my.isNotSelected = function (item) {
		return !my.isSelected(item);
	};

	my.selectItem = function (item) {
		const newItems = that.getValue() || [];
		newItems.push(item);
		that.setValue(newItems);
	};

	my.unselectItem = function (item) {
		const newItems = that.getValue() || [];
		const index = newItems.indexOf(item);
		if (index === -1) {
			return;
		}

		newItems.splice(index, 1);
		that.setValue(newItems);
	};

	my.selectAllItems = function () {
		that.setValue(my.items.slice());
	};

	my.unselectAllItems = function () {
		that.setValue([]);
	};

	return that;
}

export default multipleFieldWidget;
